import { DirectiveOptions } from 'vue';
import { isInParent } from '@/shared/filters/utils-filter';

let scrollEvent = () => {};

let determineScrollPosition = (firstChild: any, lastChild: any) => {
    var firstIsVisible = isInParent(firstChild);
    var lastIsVisible = isInParent(lastChild);

    if(firstIsVisible && lastIsVisible) {
        return undefined;
    } else if(firstIsVisible && !lastIsVisible) {
        return "top";
    } else if(!firstIsVisible && lastIsVisible) {
        return "bottom";
    } else {
        return "middle";
    }
}

const directive: DirectiveOptions = {
    inserted(el, binding, node) {
        el.classList.add("vuw-scroll-position");

        var firstChild = el.children[0];
        var lastChild = el.children[el.children.length - 1];

        let scrollEvent = () => {
            el.dataset.scrollPosition = determineScrollPosition(firstChild, lastChild);
        }

        el.dataset.scrollPosition = determineScrollPosition(firstChild, lastChild);        
        el.addEventListener('scroll', scrollEvent);
    },
    unbind(el, binding, node) {
        el.classList.remove("vuw-scroll-position");
        el.removeEventListener('scroll', scrollEvent);
    }
};

export default directive;